import style from './Styles/index.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faExclamationCircle,
    faQuestion,
} from '@fortawesome/free-solid-svg-icons'
import React, { useState } from 'react'
import { useAppDispatch } from '../../../hooks/useAppDispatch'
import {
    setDescriptionWindowData,
    showDescriptionWindow,
} from '../../../store/actions/descriptionWindowActions'
import { withTooltip } from 't4b-core-frontend'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import DOMPurify from 'dompurify'
import { NoData } from '../../NoData'
import { Placement } from 'react-bootstrap/types'

interface DescriptionBtnProps {
    type: 'validation' | 'small' | 'default'
    header: string
    description: string
    className?: string
    placement?: Placement
}

export const DescriptionBtnWithPopup = (props: DescriptionBtnProps) => {
    const { type, header, description, className, placement = 'top' } = props

    const dispatch = useAppDispatch()
    const [show, setShow] = useState(false)

    const isString = typeof description === 'string'
    const hasHrTag = isString && description.includes('<hr>')
    const shortDescription = hasHrTag
        ? description.split('<hr>')[0]
        : description
    const sanitizedHTML = isString
        ? DOMPurify.sanitize(shortDescription, {
              USE_PROFILES: { html: true },
          })
        : ''

    const handleOnMouseEnter = () => {
        setShow(true)
    }
    const handleOnMouseLeave = () => {
        setShow(false)
    }
    const HandleOnPopoverMouseEnter = () => {
        setTimeout(() => {
            setShow(true)
        }, 0)
    }

    const handleClick = () => {
        dispatch(setDescriptionWindowData({ header, description }))
        dispatch(showDescriptionWindow())
        setShow(false)
    }

    const descriptionOverlay = (
        <Popover
            onMouseEnter={HandleOnPopoverMouseEnter}
            onMouseLeave={handleOnMouseLeave}
            id={`description-overlay-top`}
        >
            <Popover.Body>
                {description && sanitizedHTML ? (
                    <div dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />
                ) : description ? (
                    description
                ) : (
                    <NoData style={{ height: '50%' }} />
                )}
                {hasHrTag && (
                    <div
                        onClick={handleClick}
                        className={`${style.readMore} d-inline-block mt-2`}
                    >
                        <FormattedMessage id={'buttons.readMore'} />
                    </div>
                )}
            </Popover.Body>
        </Popover>
    )

    switch (type) {
        case 'small':
            return (
                <OverlayTrigger
                    overlay={descriptionOverlay}
                    show={show}
                    placement={placement}
                >
                    <span
                        onMouseEnter={handleOnMouseEnter}
                        onMouseLeave={handleOnMouseLeave}
                        className={`${style.smallQuestion} ${className}`}
                    >
                        <FontAwesomeIcon icon={faQuestion} />
                    </span>
                </OverlayTrigger>
            )

        case 'validation':
            return withTooltip(
                <span
                    onClick={handleClick}
                    className={[
                        style.smallButton,
                        'ms-2 pointer text-danger border-danger border',
                        className,
                    ].join(' ')}
                >
                    <FontAwesomeIcon icon={faExclamationCircle} />
                </span>,
                'Description',
                'descriptionBtn'
            )

        default:
            return (
                <OverlayTrigger
                    overlay={descriptionOverlay}
                    show={show}
                    placement={placement}
                >
                    <span
                        onMouseEnter={handleOnMouseEnter}
                        onMouseLeave={handleOnMouseLeave}
                        className={`${style.button} ms-2 ${className}`}
                    >
                        <FontAwesomeIcon icon={faQuestion} />
                    </span>
                </OverlayTrigger>
            )
    }
}
